var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{ref:"selectTableDialog",attrs:{"title":"关联结算批次","searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"API":_vm.API,"extraData":_vm.extraData,"getDataKey":'records',"confirmUnchecked":false,"isMultiple":false,"width":"1200px"},on:{"close":_vm.close,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }